import { ExternalLink, Rocket, Users, Target } from "lucide-react";
import { motion } from "framer-motion";

export const SkillstemCTA = () => {
  return (
    <section className="py-16 md:py-24 bg-muted/30">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center"
        >
          <div className="inline-flex items-center gap-2 bg-secondary/50 rounded-full px-4 py-2 mb-6">
            <Rocket className="h-4 w-4 text-secondary-foreground" />
            <span className="text-sm font-medium text-secondary-foreground">Advanced Career Pathways</span>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Ready for Career Acceleration?
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            we-help.in helps you discover opportunities. For structured mentoring, 
            advanced pathways, and career acceleration, explore SkillSTEM Academy.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            {[
              { icon: Target, text: "Career Mentorship" },
              { icon: Users, text: "Industry Connections" },
              { icon: Rocket, text: "Job Readiness Support" },
            ].map((item, index) => (
              <div key={index} className="flex items-center justify-center gap-2 p-4 rounded-xl bg-card border border-border">
                <item.icon className="h-5 w-5 text-primary" />
                <span className="font-medium text-foreground">{item.text}</span>
              </div>
            ))}
          </div>

          <a
            href="https://skillstem.in"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-foreground text-background px-8 py-4 rounded-xl font-semibold hover:bg-foreground/90 transition-colors"
          >
            Visit SkillSTEM Academy
            <ExternalLink className="h-4 w-4" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
